// Для возможности конфигурации без пересборки проекта в index.html подключен скрипт /js/runtime-config.js,
// который выполняется перед скриптом приложения, и в котором можно определить объект window.runtimeConfig.

const configOverrides = window.runtimeConfig || {};

const blitzUrl = process.env.VUE_APP_BLITZ_URL;

const config = {
  adminRedirectUrl: process.env.VUE_APP_ADMIN_REDIRECT_URL,
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  apiAuthUrl: process.env.VUE_APP_API_AUTH_URL,
  oidc: {
    authorizeUrl: `${blitzUrl}/oauth/ae`,
    clientId: process.env.VUE_APP_OIDC_CLIENT_ID,
    redirectUri: process.env.VUE_APP_OIDC_REDIRECT_URI,
    scope: 'openid profile',
    responseType: 'code',
    logoutUrl: `${blitzUrl}/oauth/logout`,
    postLogoutRedirectUri: process.env.VUE_APP_OIDC_REDIRECT_URI,
    profileUrl: `${blitzUrl}/profile`,
  },
};

export default Object.assign(config, configOverrides);
